<template>
  <audio ref="audio" :src="src" preload="auto" @timeupdate="checkAudioLoop"/>
</template>

<script>
export default {
  name: 'AudioPlayer',

  props: {
    src: {
      type: String,
      required: true,
    },
    start: {
      type: Number,
      default: 0,
    },
    duration: {
      type: Number,
      default: 15,
    },
    loop: {
      type: Boolean,
      default: false,
    },
    volume: {
      type: Number,
      default: 0.5, // entre 0 et 1
    },
  },

  data() {
    return {
    }
  },

  mounted() {
    this.loadMusic();
  },

  beforeDestroy() {
    const audio = this.$refs.audio
    if (audio) {
      audio.pause()
      audio.removeAttribute('src')
      audio.load()
    }
  },

  watch: {
    volume(val) {
      if (this.$refs.audio) this.$refs.audio.volume = val
    },

    src() {
      this.loadMusic();
    },
    start() {
      this.loadMusic();
    },
    duration() {
      this.loadMusic();
    }
    
  },

  methods: {
    loadMusic() {
      console.log('Loading music with src:',  this.$refs.audio, this.src, 'start:', this.start, 'duration:', this.duration)
      const audio = this.$refs.audio
      if (audio) {
        if (!this.src) {
          audio.src = "";
          this.pause();
        }else{
          audio.src = this.src;
          audio.currentTime = this.start
          audio.volume = this.volume
          this.play()
        }
      }
    },

    restart() {
      const audio = this.$refs.audio
      if (audio) {
        audio.currentTime = this.start
        audio.volume = this.volume
        audio.play()
      }
    },

    pause() {
      this.$refs.audio.pause()
    },

    play() {
      this.$refs.audio.play()
    },

    mute() {
      this.$refs.audio.muted = true
    },

    unmute() {
      this.$refs.audio.muted = false
    },

    toggleMute() {
      this.$refs.audio.muted = !this.$refs.audio.muted
    },

    setMute(cbOrValue) {
      const isMuted = typeof cbOrValue === 'function'
        ? cbOrValue(this.$refs.audio.muted)
        : cbOrValue
      this.$refs.audio.muted = isMuted
    },

    isMuted() {
      return this.$refs.audio ? this.$refs.audio.muted : false
    },

    checkAudioLoop(event) {
        const audio = event.target;
        if (audio.currentTime - this.start >= this.duration) {
            if (this.loop) {
              this.restart()
            } else {
              audio.currentTime = this.start
              this.pause()           
            }
        }
    }
  },

}
</script>